<template>
    <div class="wangeditor-richtext" v-if="isInit">
        <h3 class="edit-field-title">
            <div v-if="field.name" class="label-item">
                <p class="label-text">{{ field.desc }}</p>
                <el-tooltip class="item" effect="light" placement="bottom-start">
                    <div slot="content">
                        - name: <strong>{{ field.name }}</strong><br/>
                    </div>
                    <i class="label-icon el-icon-info"></i>
                </el-tooltip>
            </div>
        </h3>
        <wangEditor ref="editorEle" :name="field.name || randomNum" @init-complete="editorInitHandler" @editor-change="valChangeHandler" />
    </div>
</template>
<script>
import moment from 'moment';
import { loadScript } from '../../service/requestApi.js';
import wangEditor from '../wangEditor';

export default {
    name: 'wangeditor-richtext',
    props: ['field', 'autoInit'],
    data() {
        return {
            editorEle: null,
            isInit: this.autoInit,
            randomNum: parseInt(Math.random()*1000000).toString()
        }
    },
    components: {
        wangEditor
    },
    methods: {
        initData() {
            this.isInit = true;
        },
        fieldBeReady() {
            // 确认组件是否就绪
            return this.$refs['editorEle'];
        },
        getResField() {
            let htmlText = this.$refs['editorEle'].getContent();
            this.field.def_val = htmlText;
            return this.field;
        },
        editorInitHandler() {
            this.editorEle = this.$refs['editorEle'];
            this.editorEle.setContent(this.field.def_val);
        },
        valChangeHandler(val) {
            this.$emit('val-change', val);
        }
    },
    computed: {
    },
    watch: {
        // 'field'(val) {
        //     this.editorEle && this.editorEle.setContent(val.def_val);
        // }
    },
    created() {
    },
    mounted() {
    }
}
</script>
<style lang="less">
    @import (reference) '../../styles/public.less';
    .wangeditor-richtext {
        // width: 600px;
        .label-item();
        // padding-bottom: 100px;
        .edit-field-title {
            font-size: 14px;
            margin-bottom: 5px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/compEditForm/wangeditorRichtext.vue